import CarrierVehicleEditModal from './styled';

export default CarrierVehicleEditModal;
